import * as React from "react";
import { forwardRef } from "react";
const SvgDownMenu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 15, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 3.266c.002-.523.113-1.04.325-1.516A2.9 2.9 0 0 1 1.37.485C1.83.175 2.367.007 2.917 0h13.727c.551.007 1.089.175 1.548.485s.822.75 1.044 1.265a3.57 3.57 0 0 1-.423 3.683l-6.864 8.499c-.26.333-.59.602-.965.787a2.72 2.72 0 0 1-2.407 0 2.8 2.8 0 0 1-.964-.787l-6.864-8.5A3.48 3.48 0 0 1 0 3.267" }));
const ForwardRef = forwardRef(SvgDownMenu);
export { ForwardRef as ReactComponent };
